export default __webpack_public_path__ + "39c65dcc08f7edb347b62cee45cd7048.gif";